module.exports = __webpack_public_path__ + "img/02_maska_krug_1.db67ba3.svg";